import { customAlphabet } from "nanoid";

/**
 * Generate (hopefully) unique key for component.
 * @returns {string} 8-character key.
 */
export const componentNanoid = customAlphabet(
    "1234567890abcdefghijklmnopqrstuvwxyz",
    8
);
